import React, { useState } from "react";
import usePost from "../../customHooks/usePost/UsePost";
import CustomToast from "../../atomic/customToast/CustomToast";

export default function VenorForm() {
  const [formDataState, setFormDataState] = useState({});
  const post = usePost();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDataState({ ...formDataState, [name]: value });
  };
  const onSuccess = (data) => {
    CustomToast({ type: "success", message: `request complete successfully` });
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    await post.postData(
      "add_request_price",
      { ...formDataState, vendor_id: 1 },
      onSuccess
    );
  };
  return (
    <div>
      <form onSubmit={onSubmit}>
        <div className="form-floating mb-3">
          <input
            type="text"
            className="form-control border-bottom"
            id="floatingInput"
            placeholder="name@example.com"
            name="message"
            value={formDataState?.message}
            onChange={handleChange}
          />
          <label htmlFor="floatingInput">Message</label>
          <span class="book-now-icon">
            <i class="fa-lg fa-regular fa-message"></i>
          </span>
        </div>
        <div className="form-floating mb-3">
          <input
            type="text"
            className="form-control border-bottom"
            id="floatingInput"
            placeholder="name@example.com"
            name="first_name"
            value={formDataState?.first_name}
            onChange={handleChange}
          />
          <label htmlFor="floatingInput">First Name</label>
          <span class="book-now-icon">
            <i class="fa-lg fa-regular fa-user"></i>
          </span>
        </div>
        <div className="form-floating mb-3">
          <input
            type="text"
            className="form-control border-bottom"
            id="floatingInput"
            placeholder="name@example.com"
            name="last_name"
            value={formDataState?.last_name}
            onChange={handleChange}
          />
          <label htmlFor="floatingInput">Last Name</label>
          <span class="book-now-icon">
            <i class="fa-lg fa-regular fa-user"></i>
          </span>
        </div>
        <div className="form-floating mb-3">
          <input
            type="email"
            className="form-control border-bottom"
            id="floatingInput"
            placeholder="name@example.com"
            name="email"
            value={formDataState?.email}
            onChange={handleChange}
          />
          <label htmlFor="floatingInput">Email</label>
          <span class="book-now-icon">
            <i class="fa-lg fa-solid fa-envelope"></i>
          </span>
        </div>
        <div className="form-floating mb-3">
          <input
            type="tel"
            className="form-control border-bottom"
            id="floatingInput"
            placeholder="name@example.com"
            name="phone"
            value={formDataState?.phone}
            onChange={handleChange}
          />
          <label htmlFor="floatingInput">Mobile Number</label>
          <span class="book-now-icon">
            <i class="fa-lg fa-solid fa-phone"></i>
          </span>
        </div>
        <div className="form-floating mb-3">
          <input
            type="date"
            className="form-control border-bottom"
            id="floatingInput"
            placeholder="name@example.com"
            name="event_date"
            value={formDataState?.event_date}
            onChange={handleChange}
          />
          <label htmlFor="floatingInput">Date</label>
        </div>
        <div className="form-floating mb-3">
          <input
            type="text"
            className="form-control border-bottom"
            id="floatingInput"
            placeholder="name@example.com"
            name="guest"
            value={formDataState?.guest}
            onChange={handleChange}
          />
          <label htmlFor="floatingInput">Guest</label>
          <span class="book-now-icon">
            <i class="fa-lg fa-solid fa-users"></i>
          </span>
        </div>
        <div>
          <label
            htmlFor="exampleFormControlInput1"
            className="form-label d-block"
          >
            Preferred contact method
          </label>
          <div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="preferred_contact_method"
                id="inlineRadio1"
                value="phone"
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="inlineRadio1">
                Phone
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="preferred_contact_method"
                id="inlineRadio2"
                value="email"
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="inlineRadio2">
                Email
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="preferred_contact_method"
                id="inlineRadio2"
                value="whatsapp"
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="inlineRadio2">
                Whatsapp
              </label>
            </div>
          </div>
        </div>
        <div className=" mt-2">
          <button className="btn btn-primary w-100 bg-book-now" type="submit">
            Send
          </button>
        </div>
      </form>
    </div>
  );
}
